import updateCategory from '../orchestrators/updateCategory';
import { OptionCategory } from 'owa-options-core';
import { action, orchestrator } from 'satcheljs';

const selectCategory = action('selectCategory', (category: OptionCategory) => ({ category }));
export default selectCategory;

orchestrator(selectCategory, actionMessage => {
    const category = actionMessage.category;
    const currentSubCategoryKey =
        category.subcategories && category.subcategories[0] && category.subcategories[0].key;
    updateCategory(category.key, currentSubCategoryKey, null);
});
